import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { OffersService } from '../../services/offers.service';
import { of } from 'rxjs';
import { ApiEffects } from '../../../../utils/effects.util';
import { Store } from '@ngrx/store';
import { selectHubOffers, selectHubOffersState, selectOfferOffers } from '../selectors/offers.selectors';
import {
  loadHubOffers,
  loadHubOffersFailure,
  loadHubOffersSuccess,
  loadOfferOffers,
  loadOfferOffersFailure,
  loadOfferOffersSuccess,
} from '../actions/offers.actions';

@Injectable()
export class OffersEffects extends ApiEffects {
  constructor(
    readonly actions$: Actions,
    private readonly offersService: OffersService,
    private readonly store: Store
  ) {
    super(actions$);
  }

  loadHubOffers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadHubOffers),
      withLatestFrom(this.store.select(selectHubOffers)),
      switchMap(([action, cachedRes]) => {
        // if state value already exists, don't dispatch again
        if (cachedRes) {
          return of(loadHubOffersSuccess({ data: cachedRes }));
        }
        return this.offersService.getOffers(action.source).pipe(
          take(1),
          map((data) => loadHubOffersSuccess({ data })),
          catchError((error) => of(loadHubOffersFailure({ error })))
        );
      })
    );
  });
  loadOfferOffers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadOfferOffers),
      withLatestFrom(this.store.select(selectOfferOffers)),
      switchMap(([action, cachedRes]) => {
        // if state value already exists, don't dispatch again
        if (cachedRes) {
          return of(loadOfferOffersSuccess({ data: cachedRes }));
        }
        return this.offersService.getOffers(action.source).pipe(
          take(1),
          map((data) => loadOfferOffersSuccess({ data })),
          catchError((error) => of(loadOfferOffersFailure({ error })))
        );
      })
    );
  });
}
